import { render, staticRenderFns } from "./postMessage.vue?vue&type=template&id=b7a29b20"
import script from "./postMessage.vue?vue&type=script&lang=js"
export * from "./postMessage.vue?vue&type=script&lang=js"
import style0 from "./postMessage.vue?vue&type=style&index=0&id=b7a29b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports